import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useCallback } from 'react';
import servicePackageActions from '~/store/actions/servicePackageAction';

export const useCheckoutPackageOffer = () => {
	const dispatch = useDispatch();
	const {
		selectedServices,
		availablePackages,
		recommendedPackages,
		loading,
		error,
		showPackageOffer: showPackageOfferState,
		acceptedPackage,
	} = useSelector((store) => store.checkoutPackageOffer);

	// Auto-analisar quando serviços mudarem
	useEffect(() => {
		if (selectedServices.length > 0 && availablePackages.length > 0) {
			dispatch(servicePackageActions.analyzeSelectedServices(selectedServices, availablePackages));
		}
	}, [selectedServices, availablePackages, dispatch]);

	const setSelectedServices = useCallback((services) => {
		dispatch(servicePackageActions.setSelectedServices(services));
	}, [dispatch]);
	
	const loadAvailablePackages = useCallback((businessId, language) => {
		dispatch(servicePackageActions.loadAvailablePackages(businessId, language));
	}, [dispatch]);
	
	const analyzeSelectedServices = useCallback((services, packages) => {
		dispatch(servicePackageActions.analyzeSelectedServices(services, packages));
	}, [dispatch]);
	
	const acceptPackageOffer = useCallback((packageId) => {
		dispatch(servicePackageActions.acceptPackageOffer(packageId, recommendedPackages));
	}, [dispatch, recommendedPackages]);
	
	const declinePackageOffer = useCallback(() => {
		dispatch(servicePackageActions.declinePackageOffer());
	}, [dispatch]);
	
	const showPackageOffer = useCallback(() => {
		dispatch(servicePackageActions.showPackageOffer());
	}, [dispatch]);
	
	const hidePackageOffer = useCallback(() => {
		dispatch(servicePackageActions.hidePackageOffer());
	}, [dispatch]);
	
	const clearPackageOffers = useCallback(() => {
		dispatch(servicePackageActions.clearPackageOffers());
	}, [dispatch]);

	const actions = {
		setSelectedServices,
		loadAvailablePackages,
		analyzeSelectedServices,
		acceptPackageOffer,
		declinePackageOffer,
		showPackageOffer,
		hidePackageOffer,
		clearPackageOffers,
	};

	// Helpers
	const helpers = {
		hasPackageOffers: recommendedPackages.length > 0,
		bestOffer: recommendedPackages[0] || null,
		totalSavings: recommendedPackages.reduce((sum, pkg) => sum + (pkg.savings || 0), 0),
		isLoading: loading,
		hasError: !!error,
	};

	return {
		// Estado
		selectedServices,
		availablePackages,
		recommendedPackages,
		loading,
		error,
		showPackageOffer: showPackageOfferState,
		acceptedPackage,
		
		// Ações
		...actions,
		
		// Helpers
		...helpers,
	};
};

export default useCheckoutPackageOffer;
